/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import WebsiteIcon from '../icons/website.svg';
import TwitterIcon from '../icons/x-icon.svg';
import TelegramIcon from '../icons/telegram.svg';
import { useHistory } from 'react-router-dom';
import { useAccount } from 'wagmi'
import KYCModal from './KYCModal.tsx';
import axios from 'axios';
import { apiUrl } from '../utils/constants.ts';
import confirmLogo from '../icons/confirm.png';
import { toast } from 'react-hot-toast';

// Toggleable features
const SHOW_SOCIAL_ICONS = true;

// eslint-disable-next-line no-unused-vars
const LaunchpadCard = ({
  chainId,
  progress,
  Liquidity, // No se usa pero se mantiene para compatibilidad
  tokenName,
  tokenDescription,
  Logo,          // optional React element
  Banner,        // optional URL string
  logoUrl: logoUrlProp,   // new URL prop
  bannerUrl: bannerUrlProp,// new URL prop
  funAddress,
  depositedAmount, // No se usa pero se mantiene para compatibilidad
  contractAddress,
  tokenAddress,
  dexAddress,
  devAddress,
  dexName,
  marketCap,    // No se usa pero se mantiene para compatibilidad
  website,
  twitter,
  telegram,
  BlockchainLogo,
  blockchainLogoUrl, // Añadimos esta propiedad para manejar correctamente el logo de blockchain
  raisingPercent,
  onMouseEnter,
  onMouseLeave,
  showKYCButton = false,
  isLive = false,   // ← new prop
}) => {
  // prefer explicit URL props, fallback to Banner/Logo element
  const initialBannerUrl = bannerUrlProp ?? Banner;
  const initialLogoUrl   = logoUrlProp   ?? Logo?.props?.src;

  // state for validated URLs
  const [bannerUrl, setBannerUrl] = useState(false);
  const [logoUrl, setLogoUrl]     = useState(false);
  const [isKYCOpen, setIsKYCOpen] = useState(false);
  const { address } = useAccount()
  const [kycSubmissions, setKycSubmissions] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [kycSubmissions] = await Promise.all([
          axios.get(`${apiUrl}/api/getKycSubmissions`),
        ]);
        setKycSubmissions(kycSubmissions.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData()
  }, [])

  const kycDatas = kycSubmissions.filter((kycSubmission) =>
    kycSubmission.tokenAddress === tokenAddress
  );

  // load banner once
  useEffect(() => {
    if (initialBannerUrl) {
      const img = new Image();
      img.onload  = () => setBannerUrl(initialBannerUrl);
      img.onerror = () => setBannerUrl(false);
      img.src     = initialBannerUrl;
    }
  }, [initialBannerUrl]);

  // load logo once
  useEffect(() => {
    if (initialLogoUrl) {
      const img = new Image();
      img.onload  = () => setLogoUrl(initialLogoUrl);
      img.onerror = () => setLogoUrl(false);
      img.src     = initialLogoUrl;
    }
  }, [initialLogoUrl]);

  // eslint-disable-next-line no-unused-vars
  const link = `/buy/?chain=${chainId}&address=${funAddress}`;

  // Add HTTPS to social links if missing
  if (website && !website?.includes('https')) {
    website = 'https://'.concat(website);
  }
  if (telegram && !telegram?.includes('https')) {
    telegram = 'https://'.concat(telegram);
  }
  if (twitter && !twitter?.includes('https')) {
    twitter = 'https://'.concat(twitter);
  }

  // eslint-disable-next-line no-unused-vars
  const [isTooltipDisplayed] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const handleInnerLinkClick = (event) => {
    event.stopPropagation();
    const innerHref = event.currentTarget.getAttribute('data-href');
    if (innerHref) {
      window.location.href = innerHref;
    }
  };

  // eslint-disable-next-line no-unused-vars
  const copyToClipboard = async (text, type = 'Address') => { // Added type parameter
    if (!navigator.clipboard) {
      toast.error('Clipboard API not available.');
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${type} copied!`); // Use toast for feedback
    } catch (err) {
      console.error('Failed to copy: ', err);
      toast.error('Failed to copy.'); // Error toast
    }
  };

  return (
    <div className='relative'>
      {showKYCButton && kycDatas.length === 0 && devAddress === address && (
        <button
          // Apply base style for mobile, override for medium screens and up
          className="absolute bottom-[180px] md:bottom-[200px] right-4 bg-[#45c0be] hover:bg-[#35b0ae] text-white py-1 px-3 rounded text-sm font-medium z-[1]" // <-- Added md:bottom-[200px]
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsKYCOpen(true);
          }}
        >
          Submit KYC
        </button>
      )}
      {showKYCButton && kycDatas[0]?.status === "pending" && devAddress === address && (
        <button
          // Apply base style for mobile, override for medium screens and up
          className="absolute bottom-[180px] md:bottom-[200px] right-4 bg-[#45c0be] hover:bg-[#35b0ae] text-white py-1 px-3 rounded text-sm font-medium z-[1]" // <-- Added md:bottom-[200px]
        >
          Pending KYC
        </button>
      )}
      <div
        className="launchpad-card cursor-pointer"
        onClick={() =>
          history.push(`/buy/?chain=${chainId}&address=${funAddress}`)
        }
      >
        <div className="launchpad-card overflow-hidden relative hover:scale-95 h-auto bg-[#050f1a] rounded-lg border border-gray-700 shadow-sm min-w-[189px] mx-auto transition-transform duration-200"> {/* Ajustado min-width y eliminado margin-1 */}
          {/* Banner y Logo en diseño más compacto */}
          <div className="relative">
            {/* Banner con gradiente superpuesto para mejor contraste con el texto */}
            <div className="relative h-20 w-full overflow-hidden"> {/* Aumentado a h-20 para más espacio */}
              {bannerUrl ? (
                <div className="relative w-full h-full">
                  <img
                    src={bannerUrl}
                    className="object-cover object-center w-full h-full"
                  />
                  {/* Gradiente superpuesto para mejorar legibilidad */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050f1a] to-transparent opacity-70"></div>
                </div>
              ) : (
                <div className="bg-gradient-to-r from-[#1c5290] to-[#45c0be] w-full h-full"></div>
              )}

              {/* Badge LIVE - movido dentro del banner para ahorrar espacio */}
              {isLive && (
                <div className="absolute top-2 right-2 z-10 bg-green-600 text-white text-[10px] font-medium px-2 py-0.5 rounded-sm shadow-sm flex items-center">
                  <span className="animate-pulse mr-1">●</span>
                  LIVE
                </div>
              )}
              
              {/* Nombre de token superpuesto al banner - ahorra espacio vertical */}
              <div className="absolute bottom-2 left-14 right-2 z-10"> {/* Ajustado para dar espacio al logo más grande */}
                <h3 className="font-bold text-white text-base truncate drop-shadow-md">{tokenName}</h3> {/* Aumentado a text-base (16px) */}
              </div>
            </div>
            
            {/* Logo superpuesto al banner */}
            <div className="absolute bottom-2 left-2 h-12 w-12 rounded-full border-2 border-white overflow-hidden bg-gray-800 shadow-lg"> {/* Aumentado a h-12 w-12 */}
              {logoUrl ? (
                <img src={logoUrl} alt="Token" className="h-full w-full object-cover" />
              ) : (
                <div className="bg-[#45c0be] h-full w-full"></div>
              )}
            </div>
          </div>

          {/* Información del token - todo más compacto */}
          <div className="p-3 pt-3 relative text-[13px]"> {/* Aumentado tamaño de texto base */}
            {/* Creador, KYC y blockchain juntos en una línea */}
            <div className="flex justify-between items-center mb-2 text-[11px] text-gray-400"> {/* Aumentado de 10px a 11px */}
              <div className="flex items-center">
                <span>by:</span>
                <a href={`/profile?${devAddress}`} className="ml-1 text-[#7db4e5] font-medium" target='_blank' rel='noreferrer' onClick={(e) => e.stopPropagation()}>
                  {devAddress.slice(0, 4) + '..' + devAddress.slice(-3)}
                </a>
              </div>
              <div className='flex items-center space-x-1'>
                {kycDatas && kycDatas[0]?.status === "approve" && (
                  <img src={confirmLogo} className='w-5 h-5' alt='KYC Approved' title="KYC Approved" />
                )}
                {blockchainLogoUrl && <img src={blockchainLogoUrl} className="w-5 h-5 rounded-full" alt="Blockchain" />}
                {BlockchainLogo && React.cloneElement(BlockchainLogo, { className: "w-5 h-5 rounded-full" })}
              </div>
            </div>
            
            {/* Descripción */}
            {tokenDescription && (
              <div className="mb-2">
                <p className="text-gray-300 text-[11px] line-clamp-1 overflow-hidden">{tokenDescription}</p> {/* Aumentado de 10px a 11px */}
              </div>
            )}
            
            {/* Métricas comprimidas en una fila */}
            <div className="flex justify-between text-[11px] mb-2 bg-gray-800/50 rounded p-2"> {/* Aumentado de 10px a 11px */}
              <div className="flex items-center">
                <span className="text-gray-400 mr-1">MC:</span>
                <span className="text-white font-medium">${Math.round(marketCap).toLocaleString()}</span>
              </div>
              
              <div className="flex items-center">
                <span className="text-gray-400 mr-1">Rise:</span>
                <span className={`font-medium ${raisingPercent > 0 ? "text-green-500" : raisingPercent < 0 ? "text-red-500" : "text-white"}`}>
                  {raisingPercent > 0 ? "+" : ""}{raisingPercent}%
                </span>
                {raisingPercent > 0 && (
                  <svg fill="#00ff05" viewBox="0 0 11 18" width="9" className="ml-1"> {/* Aumentado de width 8 a 9 */}
                    <g>
                      <path d="M3.21533 7.62257V16.9824C3.21533 17.5347 3.64908 17.9998 4.34309 17.9998H6.48294C7.03236 17.9998 7.6107 17.5638 7.6107 16.9824V7.62257H9.75056C10.994 7.62257 11.341 6.80866 10.647 5.90756L6.80103 0.67534C6.13594 -0.225764 4.97926 -0.225764 4.1985 0.67534L0.352553 5.90756C-0.341453 6.83773 0.00554999 7.62257 1.24898 7.62257H3.21533Z"></path>
                    </g>
                  </svg>
                )}
              </div>
            </div>
            
            {/* Progress Bar */}
            <div className="launchpad-progress-container mb-2">
              <div className="launchpad-progress-text text-[11px] flex justify-between mb-1"> {/* Aumentado de 10px a 11px */}
                <span className="text-gray-400">Progress:</span>
                <span className="text-[#7db4e5] font-medium">{Number(progress).toLocaleString()}%</span>
              </div>
              <div className="launchpad-progress-bar h-2 bg-gray-700 rounded-full overflow-hidden">
                <div
                  className="launchpad-progress-bar-filled h-full bg-gradient-to-r from-[#1c5290] to-[#45c0be]"
                  style={{ width: `${progress > 100 ? 100 : progress}%` }}
                />
              </div>
            </div>
            
            {/* Social Icons - más compactos y organizados */}
            {SHOW_SOCIAL_ICONS && (website || telegram || twitter) && (
              <div className="flex justify-end items-center space-x-2 mt-1">
                {website && (
                  <a href={website} onClick={(e) => { e.stopPropagation(); window.open(website, '_blank'); }} className="text-gray-400 hover:text-white bg-gray-800/50 rounded p-1 transition-colors">
                    <img src={WebsiteIcon} alt="Website" className="w-5 h-5" /> {/* Aumentado de w-4 h-4 a w-5 h-5 */}
                  </a>
                )}
                {twitter && (
                  <a href={twitter} onClick={(e) => { e.stopPropagation(); window.open(twitter, '_blank'); }} className="text-gray-400 hover:text-white bg-gray-800/50 rounded p-1 transition-colors">
                    <img src={TwitterIcon} alt="Twitter" className="w-5 h-5" /> {/* Aumentado de w-4 h-4 a w-5 h-5 */}
                  </a>
                )}
                {telegram && (
                  <a href={telegram} onClick={(e) => { e.stopPropagation(); window.open(telegram, '_blank'); }} className="text-gray-400 hover:text-white bg-gray-800/50 rounded p-1 transition-colors">
                    <img src={TelegramIcon} alt="Telegram" className="w-5 h-5" /> {/* Aumentado de w-4 h-4 a w-5 h-5 */}
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <KYCModal
        isOpen={isKYCOpen}
        onClose={() => setIsKYCOpen(false)}
        tokenName={tokenName}
        tokenAddress={tokenAddress}
      />
    </div>
  );
};

LaunchpadCard.propTypes = {
  progress: PropTypes.number.isRequired,
  Liquidity: PropTypes.number, // Represents TVL
  depositedAmount: PropTypes.number, // Represents Volume
  tokenName: PropTypes.string.isRequired,
  // raisingPercent: PropTypes.number.isRequired, // <-- Remove this line
  showKYCButton: PropTypes.bool,
  isLive: PropTypes.bool,
  marketCap: PropTypes.number,
  // Add other props like chainId, funAddress, tokenAddress, devAddress etc. if needed for strict checking
  chainId: PropTypes.number,
  funAddress: PropTypes.string,
  tokenAddress: PropTypes.string,
  devAddress: PropTypes.string,
  BlockchainLogo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  blockchainLogoUrl: PropTypes.string, // Añadimos esto a PropTypes
  website: PropTypes.string,
  twitter: PropTypes.string,
  telegram: PropTypes.string,
  raisingPercent: PropTypes.number, // Añadimos esta propiedad que faltaba
};


export default LaunchpadCard;
